import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { Page } from "~/components/ui/page";
import { ErrorState, Skeleton } from "~/components/ui/states";
import { fetchSavTicket, SavBackLink, SavView } from "~/features/sav/sav-view";

export const Route = createFileRoute("/_app/sav/$id")({ component: SavPage });

function SavPage() {
  const { id } = Route.useParams();
  const query = useQuery({ queryKey: ["sav", id], queryFn: () => fetchSavTicket(id) });
  if (query.isPending)
    return (
      <Page>
        <SavBackLink />
        <Skeleton className="h-8 w-60" />
        <Skeleton className="mt-6 h-96 w-full" />
      </Page>
    );
  if (query.isError)
    return (
      <Page>
        <SavBackLink />
        <ErrorState error={query.error} onRetry={() => void query.refetch()} />
      </Page>
    );
  return <SavView ticket={query.data} />;
}
